<template>
  <div class="title">
    <div class="info">
      <div class="btn">
        <!--        <span v-if="number !== ''">教室编号：{{ number }}</span>-->
        {{ status | status }}{{ time }}
      </div>
      {{ title }}
      <div class="stage">
        <span :class="stage ? 'active' : ''"> {{ stage | stage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TitleBar",
  props: {
    title: {
      type: String,
      default: ""
    },
    status: {
      type: Number,
      default: 0
    },
    time: {
      type: String,
      default: "00:00:00"
    },
    number: {
      type: String,
      default: ""
    },
    stage: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    status(val) {
      const data = {
        0: "",
        1: "未开始：",
        2: "上课中：",
        3: "已结束：",
        4: "缺课：",
        5: "已取消："
      };
      return data[val];
    },
    stage(val) {
      return val ? "上台中" : "未上台";
    }
  },
  data() {
    return {};
  },
  methods: {
    quit() {
      this.$emit("quit");
    }
  }
};
</script>

<style scoped lang="scss">
.title {
  width: 100%;
  height: 3.7vh;
  background: rgba(26, 26, 26, 0.6);
  line-height: 3.7vh;
  font-size: 1.3vh;
  color: #fff;
  text-align: center;
  .info {
    position: relative;
    width: 177.78vh;
    margin: 0 auto;
    .btn {
      display: block;
      height: 3.7vh;
      line-height: 3.7vh;
      font-size: 1.3vh;
      color: #fff;
      position: absolute;
      left: 0;
      top: 0;
      box-sizing: border-box;
      padding-left: 2.78vh;
      span {
        margin-right: 2vh;
      }
    }
    .stage {
      display: block;
      height: 3.7vh;
      line-height: 3.7vh;
      font-size: 1.3vh;
      color: #fff;
      position: absolute;
      right: 2vh;
      top: 0;
      box-sizing: border-box;
      padding-left: 2.78vh;
      span {
        display: block;
        width: 6.85vh;
        height: 2.59vh;
        line-height: 2.59vh;
        background: none;
        border-radius: 1.39vh;
        border: 1px solid #42434f;
        text-align: center;
        color: #42434f;
        margin-top: 0.4vh;
        &.active {
          color: #ff5454;
          border: 1px solid #ff5454;
        }
      }
    }
  }
}
</style>
